import { config } from "../config/config";

export function getSupportedVideoTechnology() {
  const { streamingTechnology, drmTechnology } = config.get().player;
  return `${streamingTechnology}_${drmTechnology}`;
}

export function getSupportedVideoTechnologyLowEnd() {
  const { streamingTechnologyLowEnd, drmTechnologyLowEnd } = config.get().player;
  return `${streamingTechnologyLowEnd}_${drmTechnologyLowEnd}`;
}
